/** Deep link and copy for opening the in-app Recycle bin from Ask chat. */

export const RECYCLE_BIN_APP_PATH = '/recycle-bin';

export const RECYCLE_BIN_DEEP_LINK = 'ch://recycle-bin';

export const RECYCLE_BIN_MENU_PATH = 'Tools > Recycle Bin';

export const RECYCLE_BIN_MARKDOWN_LINK = `[Open Recycle bin](${RECYCLE_BIN_DEEP_LINK})`;

const withNavigation = (sentence: string): string =>
  `${sentence} ${RECYCLE_BIN_MARKDOWN_LINK} (${RECYCLE_BIN_MENU_PATH})`;

export type RecycleBinChatNavigation = {
  recycleBinLink: string;
  recycleBinMarkdownLink: string;
  recycleBinMenuPath: string;
  recycleBinNote: string;
  undoHint: string;
  assistantReplyMustInclude: string;
};

/** Fields every recycle preview tool result should expose to the model. */
export const recycleBinPreviewNavigation = (): RecycleBinChatNavigation => ({
  recycleBinLink: RECYCLE_BIN_DEEP_LINK,
  recycleBinMarkdownLink: RECYCLE_BIN_MARKDOWN_LINK,
  recycleBinMenuPath: RECYCLE_BIN_MENU_PATH,
  recycleBinNote: withNavigation(
    'These files will be moved to the Crate Hackers recycle bin. Nothing is permanently deleted.',
  ),
  undoHint: withNavigation(
    'Undo with restore_recycled_tracks or open the Recycle bin in the app.',
  ),
  assistantReplyMustInclude: `Your reply must include the clickable link ${RECYCLE_BIN_MARKDOWN_LINK} and the menu path ${RECYCLE_BIN_MENU_PATH}.`,
});

export const recycleBinMovedMessage = (movedCount: number): string =>
  withNavigation(
    `Moved ${movedCount} file(s) to the Crate Hackers recycle bin.`,
  );

/** Fields every post-recycle execute tool result should expose to the model. */
export const recycleBinExecuteNavigation = (): Pick<
  RecycleBinChatNavigation,
  | 'recycleBinLink'
  | 'recycleBinMarkdownLink'
  | 'recycleBinMenuPath'
  | 'undoHint'
  | 'assistantReplyMustInclude'
> => ({
  recycleBinLink: RECYCLE_BIN_DEEP_LINK,
  recycleBinMarkdownLink: RECYCLE_BIN_MARKDOWN_LINK,
  recycleBinMenuPath: RECYCLE_BIN_MENU_PATH,
  undoHint: withNavigation(
    'Moved files are in the Recycle bin. Undo with restore_recycled_tracks or restore from the app.',
  ),
  assistantReplyMustInclude: `Your reply must include the clickable link ${RECYCLE_BIN_MARKDOWN_LINK} and the menu path ${RECYCLE_BIN_MENU_PATH}.`,
});
